import { Component, Input, OnInit, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {
  DxDataGridComponent,
  DxPopupComponent,
  DxTemplateDirective,
} from 'devextreme-angular';
import ArrayStore from 'devextreme/data/array_store';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { AllegatiArticoli } from 'src/app/models/allegati-articoli';
import { Articoli } from 'src/app/models/articoli';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { AllegatiArticoliService } from 'src/app/shared/services/allegati-articoli.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import * as FileSaver from 'file-saver';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { confirm } from 'devextreme/ui/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from 'src/app/shared/services/alert.service';
import { CategorieArticoli } from 'src/app/models/categorieArticoli';
import { CategorieArticoliService } from 'src/app/shared/services/categorie-articoli.service';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import { PopupGestioneArticoliMatricolaComponent } from '../../popups/popup-gestione-articoli-matricola/popup-gestione-articoli-matricola.component';
import notify from 'devextreme/ui/notify';
import {
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { PopupDisattivaArticoloComponent } from '../../popups/popup-disattiva-articolo/popup-disattiva-articolo.component';
import { firstValueFrom } from 'rxjs';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-grid-articoli',
  templateUrl: './grid-articoli.component.html',
  styleUrls: ['./grid-articoli.component.scss'],
  imports: [
    DxPopupComponent,
    DxDataGridComponent,
    DxTemplateDirective,
    PopupGestioneArticoliMatricolaComponent,
    DxoPagerComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
    DxiValidationRuleComponent,
    DxoLookupComponent,
    PopupDisattivaArticoloComponent,
    DxoExportComponent,
  ],
  standalone: true,
})
export class GridArticoliComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private articoliS = inject(ArticoliService);
  private allS = inject(AllegatiArticoliService);
  private ns = inject(NavigatorService);
  private tipiArticoliS = inject(TipiArticoliService);
  private sanitizer = inject(DomSanitizer);
  private alertS = inject(AlertService);
  private categorieArticoliS = inject(CategorieArticoliService);

  @Input() bEditable: boolean;

  dataSource: any;
  articoliList: Articoli[] = [];
  allegatiList: AllegatiArticoli[] = [];
  listTipiArticoli: TipiArticoli[] = [];
  listCatArticoli: CategorieArticoli[] = [];

  allegatiArticoloDataSourceStorage: any;
  popupImageVisible = false;
  currentImage?: SafeResourceUrl;

  collapsed = false;
  idCat?: number;

  popupGestioneMatricoleVisible = false;
  selectedArticoloGestMatricola?: Articoli;

  gestMatricole = false;

  articoloDaDisattivare?: Articoli;
  popupDisattivaArticoloVisible = false;

  constructor() {
    super();

    this.gestMatricole = this.isModVisible('Matricole');

    //Categoria - assegno la categoria a seconda del modulo attivo
    this.tipologiaHasMatricola = this.tipologiaHasMatricola.bind(this);
    this.allegatiArticoloDataSourceStorage = [];
  }

  loadLookups() {
    this.tipiArticoliS.getListTipiArticoliTemp().subscribe({
      next: (dati) => {
        this.listTipiArticoli = dati.sort((a, b) =>
          a.descrizione < b.descrizione ? -1 : 1,
        );
        this.rimappaArticoli();
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento tipi articoli', 'warning');
        }
      },
    });

    this.allS.list().subscribe({
      next: (dati) => {
        this.allegatiList = dati;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento dati allegati', 'warning');
        }
      },
    });

    this.categorieArticoliS.listTemp().subscribe({
      next: (dati) => {
        this.listCatArticoli = dati.sort((a, b) =>
          a.descrizione < b.descrizione ? -1 : 1,
        );
      }
    });
  }

  loadListArticoli() {
    this.articoliS.list(false).subscribe({
      next: (dati) => {
        this.articoliList = dati;
        this.rimappaArticoli();
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento articoli', 'warning');
        }
      },
    });
  }

  rimappaArticoli() {
    //Rimappo l'oggetto e recupero la categoria di riferimento
    if (this.articoliList && this.listTipiArticoli) {
      this.articoliList = this.articoliList.map((item) => {
        const newItem = item;
        const categoria = this.listTipiArticoli?.find(
          (x) => x.id == item.idTipo,
        );
        if (categoria != null) {
          item.idCategoria = categoria.idCategoria;
        }
        return newItem;
      });
      //console.log(this.articoliList);

      this.loadArticoli();
    }
  }

  loadArticoli() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return this.articoliList;
      },
      insert: (values) => {
        return firstValueFrom(this.articoliS.insert(values))
          .then(() => {
            this.articoliS.listTemp(true).subscribe();
            this.loadListArticoli();
            this.alertS.sendClickEvent();
            return values;
          })
          .catch(() => {
            throw 'Insertion failed';
          });
      },
      remove: (values) => {
        //console.log(values);
        return firstValueFrom(this.articoliS.remove(values))
          .then(() => {
            this.articoliS.listTemp(true).subscribe();
            this.loadListArticoli();
            this.alertS.sendClickEvent();
          })
          .catch((error: HttpErrorResponse) => {
            //throw 'Deletion failed'
            console.log(error.error.title);
            //notify((error.error).title, "warning");
            throw error.error.title;
          });
      },
      update: (key, values) => {
        return firstValueFrom(this.articoliS.update(key, values))
          .then(() => {
            this.articoliS.listTemp(true).subscribe();
            this.loadListArticoli();
            this.alertS.sendClickEvent();
          })
          .catch(() => {
            throw 'Update failed';
          });
      },
    });
  }

  onUpdating(e: any) {
    // e.cancel = new Promise((resolve, reject) => {
    //   resolve('');
    // });
    for (const k in e.oldData) {
      if (e.newData[k] == undefined) {
        e.newData[k] = e.oldData[k];
      }
    }
  }

  onRowPrepared(e: any) {
    if (e.rowType == 'data' && !e.data.attivo) {
      e.rowElement.style.color = '#bbbbbb';
    }
  }

  ngOnInit() {
    this.loadLookups();
    this.loadListArticoli();
    //this.categorieArticoliS.list().subscribe((dati) => {this.listCatArticoli = dati.sort((a, b) => (a.descrizione < b.descrizione) ? -1 : 1); });
  }

  getAllegati(idArticolo: number) {
    let item = this.allegatiArticoloDataSourceStorage.find(
      (i: any) => i.idArticolo === idArticolo,
    );
    if (!item) {
      item = {
        idArticolo: idArticolo,
        dataSourceInstance: new DataSource({
          store: new ArrayStore({
            data: this.allegatiList,
            key: 'id',
          }),
          filter: ['idArticolo', '=', idArticolo],
        }),
      };
      this.allegatiArticoloDataSourceStorage.push(item);
    }
    return item.dataSourceInstance;
  }

  scaricaFile(allegato: AllegatiArticoli) {
    this.allS.scarica(allegato.id).subscribe((res) => {
      FileSaver.saveAs(res, allegato.nomeFile);
    });
  }

  eliminaFile(allegato: AllegatiArticoli) {
    const result = confirm('<i>Vuoi eliminare l\'allegato?</i>', 'Conferma');
    result.then((dialogResult) => {
      if (dialogResult) {
        this.allS.delete(allegato.id).subscribe(() => {
          console.log('Allegato eliminato');
          this.allS.list().subscribe((dati) => {
            this.allegatiList = dati;
            //console.log(dati);
            this.allegatiArticoloDataSourceStorage = [];
          });
        });
      }
    });
  }

  visualizzaFile(allegato: AllegatiArticoli) {
    this.allS.scarica(allegato.id).subscribe((res) => {
      const url = window.URL.createObjectURL(res);
      window.open(url);
    });
  }

  visualizzaImmagine(allegato: AllegatiArticoli) {
    this.allS.getImmagine(allegato.id).subscribe((res) => {
      this.currentImage = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image;base64,' + res,
      );
      this.popupImageVisible = true;
    });
  }

  goToAllega(idArticolo: number) {
    this.ns.goToAllega(idArticolo);
  }

  endsWith(str: any, suffix: any) {
    if (str == undefined) {
      return false;
    }
    return (
      str
        .toUpperCase()
        .indexOf(suffix.toUpperCase(), str.length - suffix.length) !== -1
    );
  }

  goToDetail(e:any) {
    this.ns.goToArticoliDashboard(e.id);
  }

  onPopupGestioneMatricoleEvent() {
    this.popupGestioneMatricoleVisible = false;
    this.selectedArticoloGestMatricola = null;
  }

  onGestMatricolaTemplateClick(event: any) {
    this.selectedArticoloGestMatricola = event.data;
    this.popupGestioneMatricoleVisible = true;
  }

  tipologiaHasMatricola(idTipo: number) {
    try {
      const mat = this.listTipiArticoli?.find((t) => t.id == idTipo);
      if (mat == undefined){
        notificaMessaggio("Articolo non trovato nel controllo matricola", "warning");
        return;
      }
      return mat.usaMatricola;
    } catch (error) {
      console.log('Error in tipologia has matricola: ' + error);
      return false;
    }
  }

  onDisattivaArticoloClick(e: any) {
    this.articoloDaDisattivare = e.data;
    this.popupDisattivaArticoloVisible = true;
  }

  onPopupDisattivaArticoloEvent(e: any) {
    this.popupDisattivaArticoloVisible = false;
    this.articoloDaDisattivare = null;
    if (e) {
      this.rimappaArticoli();
    }
  }

  onExporting(e: any) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('articoli');
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer: any) => {
        FileSaver.saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          'articoli.xlsx',
        );
      });
    });
    e.cancel = true;
  }
}
